import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import { actions, hooks, selectors } from 'farmx-redux-core';
import { RanchBlockSelect } from './RanchBlockSelect';
import { SensorSummaryList } from './SensorSummaryList';
import { PageHeader } from '../components/PageHeader';
import { isMobile } from '../../../utils/detectDevice';
import './list.css';

const {
  selectLoadingSensors,
  selectInstallState,
} = selectors;

const { setInstallState } = actions;

const { useRanchBlockSelection } = hooks;

export function ListPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const loadingSensors = useSelector((state) => selectLoadingSensors(state));
  const installState = useSelector((state) => selectInstallState(state));

  const { selectedObjFromState, blockArray } = useRanchBlockSelection();

  const onToggleChange = (isChecked) => {
    if (isChecked) {
      dispatch(setInstallState('installed'));
    } else {
      dispatch(setInstallState(undefined));
    }
  }
  
  const text = t('Show Installed Devices Only');

  return (
    <div className="div-default padding-10 page-content device-summary-list">
      <div className="inline-page-loader-div">
        <div className="desktop-container">
          <div className='flex-space-between'>
            <div className="inline-page-loader-div">
              <PageHeader
                data-testid="list-title"
                title={t('Devices Summary')}
              />
              {loadingSensors.loading ? (
                <div className="loader-common">
                  <LoadingOutlined />
                </div>
              ) : null}
            </div>
            <div className='toggle-switch-div'>
              <Tooltip
                title={isMobile ? text : ''}
                trigger={isMobile ? 'click' : 'hover'}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                className='toggle-text'
              >
                <div
                 className={isMobile ? 'toggle-text-ellipsis' : ''}
                >
                 {text}
                </div>
              </Tooltip>
              <Switch
                checked={!!installState}
                onChange={onToggleChange}
                className='toggleSwitch'
              />
            </div>
          </div>

          {isMobile
          && (
          <RanchBlockSelect
            selectedObj={selectedObjFromState}
          />
          )}
          <SensorSummaryList
            blocks={blockArray}
            selectedObj={selectedObjFromState}
          />
        </div>
      </div>
    </div>
  );
}

ListPage.defaultProps = {
  history: {},
};

ListPage.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.object,
  }),
};
